export default __webpack_public_path__ + "static/media/telegram.881058bd.svg";